import { getBackgroundCSS } from '../../../../Components/utils/getCSS';

const Style = ({ attributes, clientId }) => {
	const { background, width, height, alignment } = attributes;

	const mainSl = `#bChart-${clientId}`;
	const chartSl = `${mainSl} .bChart`;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${mainSl}{
			text-align: ${alignment};
		}
		${chartSl}{
			height: ${height};
		}
		${chartSl},
		${mainSl} .downloadArea{
			width: ${width};
		}
		${chartSl} canvas{
			${getBackgroundCSS(background)};
		}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;